const findElement = (_target, callback = false) => {
  const findElementFunc = (_target) => {
    const element = document.querySelector(_target);
    if (element) {
      observer.disconnect();
      if (callback) {
        callback(element);
      }
    }
  }

  const observer = new MutationObserver(function(mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        findElementFunc(_target);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
  findElementFunc(_target);
}

document.addEventListener("DOMContentLoaded", function () {
  findElement('.menu-popup__warning', (element) => {
    console.log("Element found with callback:", element);
    element.querySelectorAll("button").forEach(button => {
      const span = document.createElement('span');
      span.textContent = "ADA";
      span.style.display = "none";
      button.append(span);
    });
  });

  findElement('.dz-hidden-input', (element) => {
    console.log("Element found with callback:", element);
    element?.setAttribute('aria-label', 'ADA')
  });

  findElement('.g-recaptcha-response', (element) => {
    console.log("Element found with callback:", element);
    element?.setAttribute('aria-label', 'ADA')
  });
});